import { render, staticRenderFns } from "./DlgModeratorsDelete.vue?vue&type=template&id=a919ea18&scoped=true&"
import script from "./DlgModeratorsDelete.vue?vue&type=script&lang=js&"
export * from "./DlgModeratorsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a919ea18",
  null
  
)

export default component.exports